const StatusButton = ({status, statusColor}: {status: string; statusColor: string}) => {
  return (
    <button
      type='button'
      className={`shadow-none btn btn-sm btn-outline btn-outline-${statusColor}`}
    >
      {status}
    </button>
  )
}

export default StatusButton
